


import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import MenuMobEs from './MenuMobEs';
import MenuDeskEs from './MenuDeskEs';


const MenuEs = ({ changeLanguage, navigateTo }) => {
  /* debugger; */
 /*  const { setCurrentLang} = props ; */
   
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const handleTouchStart = () => {
      setIsTouchDevice(true);
    };

    const handleMouseDown = () => {
      setIsTouchDevice(false);
    };

    // Agrega los listeners de eventos
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('mousedown', handleMouseDown);

    // Limpia los listeners cuando el componente se desmonta
    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const shouldUseMobileMenu = isMobile   && window.innerWidth <= 750;
  


  /* const shouldUseMobileMenu = isMobile || (isTouchDevice && window.innerWidth <= 750); */

  return (
    <div>
       {shouldUseMobileMenu ?  <MenuMobEs changeLanguage={changeLanguage}  />  :  <MenuDeskEs  changeLanguage={changeLanguage} /> }
       
    </div>
  );
};
 

export default MenuEs;